import classes from './header.module.scss';
import PhoneIcon from '@icons/PhoneIcon';
import { observer } from 'mobx-react';
import { useStore } from '~/shared/hooks/useStore';
import { buildApiString } from '~/shared/lib/helpers';
import { useYandexHit } from '~/processes/providers/yandexMetrika/hooks/useYandexHit';
import { EYMActions } from '~/processes/providers/yandexMetrika/entity';
import LanguageSelector from '../../shared/components/LanguageSelector';
import { useLocation } from 'react-router-dom';
import { Notification } from '@components/TechnologistsComments';
import { BurgerMenu } from '@components/Burger';
// import QuestionIcon from '~/assets/icons/question';

const Header = () => {
    const { CCompanyInfo, CLinks } = useStore();
    const { logo, title, phone, website } = CCompanyInfo.companyInfo;
    const { ymHit } = useYandexHit();
    const location = useLocation();
    const { referal } = CLinks.links;
    
    const handleClickPhone = () => {
        ymHit(EYMActions.HEADER_PHONE);
    };

    const handleClickLogo = () => {
        ymHit(EYMActions.HEADER_LOGO);
    };

    const formatUrl = (addr: string): string => {
        try {
            new URL(addr);

            return addr;
        } catch (error) {
            const newURL = `https://${addr}`;

            try {
                new URL(newURL);

                return newURL;
            } catch (error) {
                return '';
            }
        }
    };

    const renderLogo = () => (
        <a onClick={handleClickLogo} href={formatUrl(website)} className={classes.logo}>
            <img
                className="h-[50px] max-h-[50px] md:min-h-[60px] lg:min-h-[80px] md:max-h-[80px] object-contain"
                src={logo ? buildApiString(logo) : './android-chrome-512x512.png'}
                alt={title}
            />
        </a>
    );

    return (
        <header className={classes.box}>
            <div className={`container ${classes.container}`}>
                {location.pathname !== '/' ? (
                    referal ? (
                        <>
                            <div>
                                <BurgerMenu />
                            </div>
                            <div className="text-center flex-1">{renderLogo()}</div>
                            <div className="text-right flex justify-end items-center sm:space-x-5 space-x-2">
                                <a
                                    className={classes.phone + ' text-sm lg:text-lg'}
                                    onClick={handleClickPhone}
                                    href={`tel:${phone}`}
                                >
                                    <span className={classes.phoneIcon}>
                                        <PhoneIcon />
                                    </span>
                                    <span className={classes.phoneText}>{phone}</span>
                                </a>
                                <Notification />
                                <LanguageSelector />
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="flex items-center">
                                {renderLogo()}
                            </div>
                            <div className="flex-1" />
                            <div className="text-right flex justify-end items-center sm:space-x-5 space-x-2">
                                <a
                                    className={classes.phone + ' text-sm lg:text-lg'}
                                    onClick={handleClickPhone}
                                    href={`tel:${phone}`}
                                >
                                    <span className={classes.phoneIcon}>
                                        <PhoneIcon />
                                    </span>
                                    <span className={classes.phoneText}>{phone}</span>
                                </a>
                                <Notification />
                                <LanguageSelector />
                            </div>
                        </>
                    )
                ) : (
                // Для главной страницы лого в центре
                    <div className="text-center">
                        <a onClick={handleClickLogo} href={'https://order.dry.care'} className={classes.logo}>
                            <img
                                className="h-[50px] max-h-[50px] md:min-h-[60px] lg:min-h-[80px] md:max-h-[80px] object-contain"
                                src={logo ? buildApiString(logo) : './android-chrome-512x512.png'}
                                alt={title}
                            />
                        </a>
                    </div>
                )}
            </div>
        </header>
    );
};

export default observer(Header);